import React from 'react';
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { useTimePicker } from './useTimePicker';

interface TimePickerProps {
  value: number | null;
  onChange: (minutes: number | null) => void;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  onBlur?: () => void;
  defaultPeriod?: 'AM' | 'PM';
}

export const TimePicker: React.FC<TimePickerProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder = '',
  error = false,
  onBlur,
  defaultPeriod = 'AM'
}) => {
  const {
    timeInput,
    period,
    handleTimeChange,
    handleTimeBlur,
    handlePeriodChange
  } = useTimePicker({ 
    value, 
    onChange,
    onExternalBlur: onBlur,
    defaultPeriod
  });

  return (
    <div className="w-full">
      <div className={cn(
        "flex w-full rounded-md",
        error && "border-destructive focus-within:ring-destructive"
      )}>
        <Input
          type="text"
          value={timeInput}
          onChange={handleTimeChange}
          onBlur={() => {
            handleTimeBlur();
            if (onBlur) onBlur();
          }}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(
            "rounded-r-none",
            error && "border-destructive focus-visible:ring-destructive"
          )}
        />
        <Select
          value={period}
          onValueChange={(newPeriod) => {
            handlePeriodChange(newPeriod as 'AM' | 'PM');
            if (onBlur) onBlur();
          }}
          disabled={disabled}
        >
          <SelectTrigger className={cn(
            "w-[80px] rounded-l-none border-l-0",
            error && "border-destructive focus-visible:ring-destructive"
          )}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="AM">AM</SelectItem>
            <SelectItem value="PM">PM</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
